import {Injectable} from '@angular/core';
import {BaseEndpoint} from "../../../../base/endpoints/base.endpoint";
import {environment} from "../../../../../environments/environment";
import {IParams} from "../../../../base/endpoints/iparams";

@Injectable({
  providedIn: 'root'
})
export class AuthEndpoint extends BaseEndpoint {

  constructor() {
    super();
  }

  static REGISTER = {
    SEND_OTP(params: IParams): string {
      return environment.base_url + '/api/v1/register/verify'
        + BaseEndpoint.toParamString(params)
    },
    REGISTER(params: IParams) {
      return environment.base_url + '/api/v1/register'
        + BaseEndpoint.toParamString(params)
    }
  }

  static RESET_PASSWORD = {
    REQUEST_TOKEN(params: IParams): string {
      return environment.base_url + '/api/v1/reset_password'
        + BaseEndpoint.toParamString(params)
    },

    RESET_PASSWORD(params: IParams): string {
      return environment.base_url + '/api/v1/reset_password'
        + BaseEndpoint.toParamString(params)
    }
  }

  static CHANGE_PASSWORD = {
    CHANGE(params: IParams): string {
      return environment.base_url + '/api/v1/change_password'
        + BaseEndpoint.toParamString(params)
    }
  }

  static PRE_REGISTER = {
    POST(code: string): string {
      return environment.base_url + '/api/v1/public/acquisition-campaigns/' + code + '/leads'
    }
  }

}
